import React from 'react';
import { IFooterSura } from '@components/Sura/Footer/types';
import { Grid, Typography } from '@material-ui/core';
import useStyles from '@components/Sura/Footer/style';

import FACEBOOK from '@assets/images/icons/facebook.png';
import INSTAGRAM from '@assets/images/icons/instagram.png';
import YOUTUBE from '@assets/images/icons/youtube.png';
import LINKEDIN from '@assets/images/icons/linked-in.png';
import PHONE from '@assets/images/icons/telefono.png';
import useStore from '@hooks/useStore';
import { URLS, footerItem } from '@constants/suraURLs';
import LinkComponent from './LinkComponent';

const FooterSura: React.FC<IFooterSura> = () => {
  const { ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });

  return (
    <Grid container className={css.root} spacing={ui.isMobileScreen ? 1 : 2}>
      <Grid item xs={ui.isMobileScreen ? 12 : 1}></Grid>
      <Grid item xs={ui.isMobileScreen ? 12 : 2}>
        <div>
          <Typography className={css.title}>Seguros SURA México</Typography>
          {footerItem.segurosSura.map((item, index) => (
            <LinkComponent key={index} URL={item.url} title={item.title} />
          ))}
        </div>
      </Grid>
      <Grid item xs={ui.isMobileScreen ? 12 : 2}>
        <div>
          <Typography className={css.title}>Oficinas</Typography>
          {footerItem.oficinas.map((item, index) => (
            <LinkComponent key={index} URL={item.url} title={item.title} />
          ))}
        </div>
      </Grid>
      <Grid item xs={ui.isMobileScreen ? 12 : 2}>
        <div>
          <Typography className={css.title}>Servicios</Typography>
          {footerItem.servicios.map((item, index) => (
            <LinkComponent key={index} URL={item.url} title={item.title} />
          ))}
        </div>
      </Grid>
      <Grid item xs={ui.isMobileScreen ? 12 : 2}>
        <div>
          <Typography className={css.title}>Legales</Typography>
          {footerItem.legales.map((item, index) => (
            <LinkComponent key={index} URL={item.url} title={item.title} />
          ))}
        </div>
      </Grid>
      <Grid item xs={ui.isMobileScreen ? 12 : 2}>
        <div>
          <Typography className={css.title}>Síguenos</Typography>
          <div className={css.divIcons}>
            <a target="_blank" rel="noreferrer noopener" href={URLS.FACEBOOK}>
              <img src={FACEBOOK} />
            </a>
            <a target="_blank" rel="noreferrer noopener" href={URLS.INSTAGRAM}>
              <img src={INSTAGRAM} />
            </a>
            <a target="_blank" rel="noreferrer noopener" href={URLS.LINKEDIN}>
              <img src={LINKEDIN} />
            </a>
          </div>
          <Typography className={css.title}>Línea de atención</Typography>
          <div className={css.divPhoneButton}>
            <a href="tel:8007237900" className={css.link}>
              <div className={css.divPhone}>
                <img src={PHONE} width="20px" height="19px" />
                <Typography className={css.labelPhone}>800 723 7900</Typography>
              </div>
            </a>
            <a href="tel:5557237999" className={css.link}>
              <div className={css.divPhone}>
                <img src={PHONE} width="20px" height="19px" />
                <Typography className={css.labelPhone}>555723 7999</Typography>
              </div>
            </a>
          </div>
          <a href="https://qa-portal.segurossura.com.mx/contacto/" className={css.link}>
            <div className={css.divEmail}>
              <Typography className={css.subTitle}>Contáctanos por mail</Typography>
            </div>
          </a>
        </div>
      </Grid>
      <Grid item xs={ui.isMobileScreen ? 12 : 1}></Grid>

      <Grid item xs={12}>
        <div className={css.divNotice}>
          <Typography className={css.labelLaws}>
            © 2016 SURA. Todos los derechos reservados.
          </Typography>
          <LinkComponent URL={URLS.AVISO_PRIVACIDAD} title="Aviso de privacidad integral" notice />
          <LinkComponent URL={URLS.PAYMENT_AVISO_PAGO} title="Aviso de pago recurrente" notice />
        </div>
      </Grid>
    </Grid>
  );
};

export default FooterSura;
